import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import TrademarkRegistration from './pages/services/TrademarkRegistration';
import CopyrightRegistration from './pages/services/CopyrightRegistration';
import ComprehensiveSearch from './pages/services/ComprehensiveSearch';
import CompanyFormation from './pages/services/CompanyFormation';
import AmazonBrandRegistry from './pages/services/AmazonBrandRegistry';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import LandingPage from './pages/LandingPage';

// ScrollToTop component to handle page navigation
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
            <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
            <Route path="/services/comprehensive-search" element={<ComprehensiveSearch />} />
            <Route path="/services/company-formation" element={<CompanyFormation />} />
            <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/lp/" element={<LandingPage />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
